module.exports = __webpack_public_path__ + "2fbfcbf15ba4812ecc134b7913c0f809.svg";